import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('admin@rentcarsus.com');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) nav('/admin', { replace: true });
  }, [user, nav]);

  async function submit(e) {
    e.preventDefault();
    setErr('');
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) nav('/admin', { replace: true });
    else setErr(res.error || 'Login failed');
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0D1B3E 0%, #142554 60%, #1E3A8A 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div style={{ position: 'absolute', top: -120, right: -120, width: 360, height: 360, background: 'radial-gradient(circle, rgba(230,57,70,.3), transparent 70%)' }} />
      <div style={{ position: 'absolute', bottom: -120, left: -120, width: 360, height: 360, background: 'radial-gradient(circle, rgba(16,185,129,.18), transparent 70%)' }} />

      <div className="fade-up" style={{ width: '100%', maxWidth: 420, position: 'relative' }}>
        <Link to="/" data-testid="login-brand-link" style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'center', marginBottom: 22 }}>
          <div style={{ background: '#E63946', borderRadius: 8, padding: '6px 10px', fontSize: 20 }}>🚗</div>
          <span style={{ color: '#fff', fontWeight: 900, fontSize: 20, letterSpacing: '-.02em' }}>RENTCARSUS</span>
        </Link>

        <div style={{ background: '#fff', borderRadius: 18, padding: 32, boxShadow: '0 30px 80px rgba(0,0,0,.4)' }}>
          <h1 style={{ fontSize: 24, fontWeight: 900, color: '#0F172A', margin: 0, letterSpacing: '-.02em' }}>Admin Login</h1>
          <p style={{ color: '#64748B', fontSize: 13, marginTop: 6 }}>Sign in to manage fleet and maintenance.</p>

          <form onSubmit={submit} style={{ marginTop: 22 }}>
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '.05em', marginBottom: 5 }}>Email</label>
              <input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #E2E8F0', borderRadius: 10, fontSize: 14 }}
              />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '.05em', marginBottom: 5 }}>Password</label>
              <input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="••••••••"
                style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #E2E8F0', borderRadius: 10, fontSize: 14 }}
              />
            </div>
            {err && (
              <div data-testid="login-error" style={{ background: '#FEE2E2', color: '#991B1B', borderRadius: 8, padding: '10px 12px', fontSize: 13, marginBottom: 12 }}>
                {err}
              </div>
            )}
            <button type="submit" disabled={loading} className="btn-primary" data-testid="login-submit" style={{ width: '100%', padding: '12px' }}>
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
          </form>

          <div style={{ marginTop: 18, padding: 12, background: '#F1F5F9', borderRadius: 10, fontSize: 12, color: '#64748B' }}>
            <strong style={{ color: '#0D1B3E' }}>Demo:</strong> admin@rentcarsus.com / Admin@123
          </div>
        </div>

        <div style={{ textAlign: 'center', marginTop: 18 }}>
          <Link to="/" style={{ color: 'rgba(255,255,255,.7)', fontSize: 13, fontWeight: 600 }}>
            ← Back to site
          </Link>
        </div>
      </div>
    </div>
  );
}
